import { Injectable, inject } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
    HttpResponse
} from '@angular/common/http';
import { catchError, EMPTY, map, Observable, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { SeguridadService } from '../modules/sistema/services/seguridad/seguridad.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    private _router = inject(Router);
    private _seguridadService = inject(SeguridadService);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);
    constructor() { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const impersonadoAlEnviar = this._seguridadService.esUsuarioImpersonado();
        return next.handle(request)
            .pipe(
                map((evt: HttpEvent<any>) => {
                    if (!environment.production) {
                        if (evt instanceof HttpResponse) {
                            console.log(`respuesta--->>> ${evt.url}`, evt);
                        }
                    }
                    return evt;
                }),
                catchError((error: HttpErrorResponse) => {
                    const esEndpointDeRefresh = request.url.toLowerCase().includes('seguridad/refreshtoken');
                    const hayTokenActivo = this._seguridadService.obtenerAccessToken() !== null;
                    if (error.status === 401 && !esEndpointDeRefresh && hayTokenActivo) {
                        if (impersonadoAlEnviar) {
                            if (this._seguridadService.esUsuarioImpersonado()) this._seguridadService.regresarAlUsuarioOriginal();
                            return EMPTY;
                        }
                        return this._seguridadService.refrescarTokenSiNecesario().pipe(
                            switchMap(nuevoToken => {
                                if (!nuevoToken) {
                                    this._seguridadService.limpiarSesion();
                                    this._router.navigate(['/main']);
                                    return EMPTY;
                                }
                                const retryReq = request.clone({
                                    headers: request.headers.set('Authorization', `Bearer ${nuevoToken}`)
                                });
                                return next.handle(retryReq);
                            }),
                            catchError((retryError) => {
                                if (retryError instanceof HttpErrorResponse && retryError.status !== 401) {
                                    return throwError(() => retryError.error);
                                }
                                this._seguridadService.limpiarSesion();
                                this._router.navigate(['/main']);
                                return EMPTY;
                            })
                        );
                    }

                    return throwError(() => error.error);
                })
            );
    }
}
// export const RequestInterceptorProvider = { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true };
